import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Wrap,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { useBoolean } from "usehooks-ts";

interface ExistingClosingDialogProps {
  isLoading: boolean;

  discardAndCreateClosing(): Promise<void>;
  routeToDraftClosing(): void;
  onCloseComplete(): void;
}

export const ExistingClosingDialog: React.FC<ExistingClosingDialogProps> = ({
  discardAndCreateClosing,
  isLoading,
  routeToDraftClosing,
  onCloseComplete,
}) => {
  const { t } = useTranslation(["closing", "common"]);

  const { value: isOpen, setFalse: close } = useBoolean(true);
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={close}
      onCloseComplete={onCloseComplete}
      leastDestructiveRef={cancelRef}
      size="xl"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>
          {t("closing:existingDraftModal.title")}
        </AlertDialogHeader>
        <AlertDialogBody>
          {t("closing:existingDraftModal.body")}
        </AlertDialogBody>
        <AlertDialogFooter>
          <Wrap justify="space-between" flex={1}>
            <Button
              type="button"
              colorScheme="destructive"
              onClick={async () => {
                await discardAndCreateClosing();
                close();
              }}
              isLoading={isLoading}
            >
              {t("closing:existingDraftModal.discard")}
            </Button>
            <Wrap justify="flex-end">
              <ButtonOrder
                dismiss={
                  <Button
                    ref={cancelRef}
                    type="button"
                    colorScheme="secondary"
                    onClick={close}
                    isDisabled={isLoading}
                  >
                    {t("closing:existingDraftModal.cancel")}
                  </Button>
                }
                confirm={
                  <Button
                    type="button"
                    onClick={() => {
                      close();
                      routeToDraftClosing();
                    }}
                    isDisabled={isLoading}
                  >
                    {t("closing:existingDraftModal.continue")}
                  </Button>
                }
              />
            </Wrap>
          </Wrap>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
